<template>
    <div>
        <input :class="inputClass"
               :disabled="disabled"
               :placeholder="placeHolder"
               v-debounce:500="updateOptions"
               v-model.trim="value"
               :style="{ width: inputWidth ? inputWidth + 'px !important' : 'auto'}"
               @keyup.enter="submitInput"
               @keyup.down="nextItem"
               @keyup.up="prevItem"
               @keyup.esc="items = []"
        />

        <div class="topbar__key__autocomplete">
            <ul v-if="items.length" class="topbar__key__autocomplete__list" v-click-outside="function () {items = []; oldValue = '';}">
                <li
                    v-for="(item, index) in items"
                    :key="item.id"
                    :class="{'selected': currentItem === (index + 1)}"
                    @click="itemClicked(index)"
                >
                    <template v-if="forStartups">
                        <div class="autocomplete__list__item__image">
                            <img :src="getLogo(item.logo)" alt="">
                        </div>

                        {{item.name}}
                    </template>

                    <template v-else>
                        {{item.name}}
                    </template>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>

import {getLogo} from "@/helpers/logo";

export default {
    props: {
        searchString: {
            type: String,
            default: ''
        },

        clearOnSubmit: {
            type: Boolean,
            default: true
        },

        disabled: {
            type: Boolean,
            default: false
        },

        forStartups: {
            type: Boolean,
            default: false
        },

        inputWidth: {
            type: Number,
            default: 0
        },

        placeHolder: String,

        updateFunction: {
            type: Function,
            default: null
        },

        inputClass: String,
        exclude: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            oldValue: '',
            items: [],
            currentItem: 0,
        }
    },

    computed: {
        value: {
            get() {
                return this.searchString
            },

            set(value) {
                this.$emit('update:searchString', value)
            }
        }
    },

    methods: {
        getLogo,
        updateOptions() {
            if (this.oldValue !== this.value) {

                this.items = []
                if (this.value.length && this.value.length <= 200 && this.updateFunction) {
                    this.updateFunction(this.value).then(response => {
                        let data = response.data.map(item => {
                            if (typeof item === 'string') {
                                return {id: item, name: item}
                            } else {
                                return item
                            }
                        });

                        if (this.value.length) {
                            this.items = data.filter(item => !this.exclude.some(excludeId => excludeId === item.id))
                        }
                    })
                }

                this.oldValue = this.value
            }
        },

        nextItem() {
            if (this.items.length) {
                if (this.items.length > this.currentItem) {
                    ++this.currentItem
                } else {
                    this.currentItem = 1
                }
            }
        },

        prevItem() {
            if (this.items.length) {
                if (this.currentItem > 1) {
                    --this.currentItem
                } else {
                    this.currentItem = this.items.length
                }
            }
        },

        itemClicked(index) {
            this.currentItem = index + 1;
            this.submitInput();
        },

        submitInput() {
            let text = ""

            if (this.currentItem > 0) {
                let selected = this.items[this.currentItem - 1]
                this.$emit('submitted', this.forStartups ? selected : selected.id);
                text = selected.name
            } else {
                this.$emit('submitted', this.value);
                text = this.value
            }

            this.items = []
            this.currentItem = 0

            if (this.clearOnSubmit) {
                this.clear();
            } else {
                this.oldValue = text
            }
        },

        clear() {
            this.$emit('input', '');
            this.value = '';
            this.oldValue = '';
        }
    }
}
</script>

<style scoped>
</style>
